module.exports = __webpack_public_path__ + "assets/icons/sort-c607.svg";